import { Stack, Tooltip, Typography } from "@mui/material";
import { MinutesFromNowInput } from "./minutesFromNowInput";
import { TimeInput } from "./timeInput";
import { MinutesUntilDeliveryStart } from "./minutesUntilTime";
import { useFormikContext } from "formik";
import ClearIcon from "@mui/icons-material/Clear";
import { PickerValue } from "@mui/x-date-pickers/internals";
import { ConfigTabState } from "../../types";
import { OutlinedSection } from "../outlinedSection";
import { tradeEndBeforeStart } from "./utils";

const RelativeTimeInput = (props: {
  label: string;
  fieldKey: string;
  clearTooltip: string;
  disabled?: boolean;
}) => {
  const { setFieldValue, values } = useFormikContext<ConfigTabState>();
  const tooltip = <Typography>{props.clearTooltip}</Typography>;

  const endBeforeStartError =
    props.fieldKey === "end"
      ? tradeEndBeforeStart(values.start, values.end)
      : undefined;

  return (
    <OutlinedSection
      label={props.label}
      error={endBeforeStartError}
      // The clear icon is an SVG, not a form control, so it takes no `disabled`
      // of its own — it is dropped outright rather than left looking clickable.
      action={
        props.disabled ? undefined : (
        <Tooltip title={tooltip}>
          <ClearIcon
            sx={{
              // Sits on the border opposite the legend, centred on it the same
              // way the heading is. `translateY(-50%)` derives that from the
              // icon's own height rather than hardcoding half of `fontSize`.
              position: "absolute",
              top: 0,
              transform: "translateY(-50%)",
              right: 8,
              fontSize: 16,
              cursor: "pointer",
              backgroundColor: "background.paper",
              color: endBeforeStartError ? "error.main" : "text.secondary",
            }}
            onClick={() => setFieldValue(props.fieldKey, undefined)}
          />
        </Tooltip>
        )
      }
    >
      {/* Same row rhythm as the settings column, so the fields in all three
          frames sit at matching heights. */}
      <Stack spacing={0.5} direction="column">
        <MinutesFromNowInput
          fieldKey={props.fieldKey}
          endBeforeStartError={endBeforeStartError}
          disabled={props.disabled}
        />
        <TimeInput
          fieldKey={props.fieldKey as keyof PickerValue}
          label="Absolute time (JST)"
          endBeforeStartError={endBeforeStartError}
          disabled={props.disabled}
        />
        <MinutesUntilDeliveryStart
          fieldKey={props.fieldKey}
          endBeforeStartError={endBeforeStartError}
          disabled={props.disabled}
        />
        {endBeforeStartError !== undefined && endBeforeStartError ? (
          <Typography
            variant="subtitle1"
            fontSize={10}
            color="error"
            textAlign="left"
          >
            TRADE END IS BEFORE TRADE START OR NOW
          </Typography>
        ) : null}
      </Stack>
    </OutlinedSection>
  );
};

export { RelativeTimeInput };
